import React from 'react';

interface ContactButtonProps {
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const ContactButton: React.FC<ContactButtonProps> = ({ 
  variant = 'primary', 
  size = 'md',
  className = '' 
}) => {
  const whatsappUrl = "https://api.whatsapp.com/send/?phone=593995886995&text=Hola%2C+¿me+podría+dar+información+sobre+los+servicios+de+LEXIS%3F&type=phone_number&app_absent=0";

  const baseClasses = "inline-flex items-center font-medium rounded-lg transition-colors duration-200";
  
  const variantClasses = {
    primary: "text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2",
    secondary: "text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
  };

  const sizeClasses = {
    sm: "px-4 py-2 text-sm gap-1",
    md: "px-6 py-3 text-base gap-2",
    lg: "px-8 py-4 text-lg gap-3"
  };

  const iconSizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6"
  };

  const handleClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      style={{ backgroundColor: '#1A8A98' }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0D4658'}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1A8A98'}
    >
      Contáctanos
      <svg
        className={iconSizes[size]}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M5 12h14" />
        <path d="M12 5l7 7-7 7" />
      </svg>
    </button>
  );
};

export default ContactButton;
